export function sanitizeWidth({
  width,
  widthType,
}: {
  width?: string | number;
  widthType?: string;
}): string {
  if (!width) {
    return '100%';
  }
  const sanitizedWidth = typeof width === 'string' ? width.replace(/[^\d]/g, '') : width.toString();
  const sanitizedWidthType = widthType === 'px' || widthType === '%' ? widthType : 'px';
  return sanitizedWidth + sanitizedWidthType;
}
